export default (axios) => ({
  getSimilarJobs(jobHandleId) {
    return axios.get(`/v1/api/project/${jobHandleId}/similars`)
  }
})
